<template>
    <div>
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">Стоимость услуг</h1><Breadcrumbs title="Стоимость услуг"/></div>
        </section>
        <section class="section">
            <div class="container">

            <table class="table">
            <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Услуга</th>
                <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <th scope="row">
                    <img src="/img/cost/analize.jpg"/>
                </th>
                <td><router-link to="/konsaltingovye-uslugi/">Консалтинг (расчёты, моделирование)</router-link></td>
                <td>
                    <base-button type="outline-default"
                        style="width: 150px"
                        class="btn-sm ml-2 p-2"
                        @click="showModal('Консалтинг', 'Консалтинг')">
                        Узнать цену
                    </base-button>
                </td>
                </tr>
                <tr>
                <th scope="row">
                     <img src="/img/cost/cost.jpg"/>
                </th>
                <td>Стоимость продукта</td>
                <td>
                    <base-button type="outline-default"
                        style="width: 150px"
                        class="btn-sm ml-2 p-2"
                        @click="showModal('Стоимость продукта', 'Стоимость')">
                        Узнать цену
                    </base-button>
                </td>
                </tr>
                <tr>
                <th scope="row">
                    <img src="/img/cost/demo.jpg"/>
                </th>
                <td>Предоставление демо-версий продуктов</td>
                <td>
                    <base-button type="outline-default"
                        style="width: 150px"
                        class="btn-sm ml-2 p-2"
                        @click="showModal('Предоставление демо-версий', 'Демо')">
                        Получить ссылку
                    </base-button>
                </td>
                </tr>
                <tr>
                <th scope="row">
                    <img src="/img/cost/info.jpg"/>
                </th>
                <td>Техническая информация и техническая поддержка</td>
                <td>
                    <base-button type="outline-default"
                        style="width: 150px"
                        class="btn-sm ml-2 p-2"
                        @click="showModal('Техническая информация', 'Техническая информация')">
                        Связаться
                    </base-button>
                </td>
                </tr>
                <tr>
                <th scope="row">
                    <img src="/img/cost/study.jpg"/>
                </th>
                <td>Обучение</td>
                <td>
                    <base-button type="outline-default"
                        style="width: 150px"
                        class="btn-sm ml-2 p-2"
                        @click="showModal('Обучение', 'Обучение')">
                        Подробнее
                    </base-button>
                </td>
                </tr>
            </tbody>
            </table>
            </div>
        </section>
        <CallModal ref="callModal"></CallModal>
    </div>
</template>
<script>
    import CallModal from "@/components/CallModal.vue";
    export default {
        components: {
            CallModal,
        },
        mounted() {
            this.$root.title = "Стоимость";
            this.$root.description = "Стоимость услуг, продуктов";
        },
        methods: {
            showModal(title, name) {
                this.$refs.callModal.modals.sendApply = true;
                this.$refs.callModal.modals.title = title
                this.$refs.callModal.modals.info = name
            }
        }
    };
</script>
<style>
.table td{
    vertical-align: middle !important;
}
.table img{
    width: 100px;
    height: 100px;
}
 @media (max-width: 992px) {
    .table{
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
 }
</style>